var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import shajs from "sha.js";
function getIsMobile() {
  let isMobile = false;
  (function(a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)))
      isMobile = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return isMobile;
}
const segmentProperties = {
  boolean: "Boolean",
  description: "Description",
  displayLogic: "Display Logic",
  fromUrl: "From URL",
  iconName: "Icon Name",
  location: "Location",
  page: "Page",
  region: "Region",
  section: "Section",
  text: "Text",
  toUrl: "To URL",
  value: "Value"
};
function toSegmentPayload(payload) {
  return {
    [segmentProperties.boolean]: payload.boolean,
    [segmentProperties.description]: payload.description,
    [segmentProperties.displayLogic]: payload.displayLogic,
    [segmentProperties.fromUrl]: payload.fromUrl,
    [segmentProperties.iconName]: payload.iconName,
    [segmentProperties.page]: payload.page || payload.location,
    [segmentProperties.region]: payload.region,
    [segmentProperties.section]: payload.section,
    [segmentProperties.text]: payload.text,
    [segmentProperties.toUrl]: payload.toUrl,
    [segmentProperties.value]: payload.value
  };
}
class EventManager {
  constructor(options) {
    var _a;
    this.isMobile = getIsMobile();
    this.eventProps = (_a = options == null ? void 0 : options.eventProps) != null ? _a : {};
  }
  triggerEvent(eventName, props) {
    if (!this.isEventTrackingSystemInitialized())
      return;
    const propsFromOptions = this.getPropsFromOptions();
    const eventProps = __spreadProps(__spreadValues(__spreadValues({}, toSegmentPayload(props)), propsFromOptions), {
      userDevice: {
        isMobile: this.isMobile,
        screenSize: window.screen.width
      },
      _library: "ui-events"
    });
    this.trackEvent(eventName, eventProps);
  }
  trackEvent(eventName, eventProps) {
    var _a;
    (_a = window.analytics) == null ? void 0 : _a.track(eventName, eventProps);
  }
  isEventTrackingSystemInitialized() {
    return window && window.analytics;
  }
  getPropsFromOptions() {
    const props = {};
    Object.entries(this.eventProps).forEach(([key, value]) => {
      try {
        props[key] = typeof value === "function" ? value() : value;
      } catch (err) {
        console.log(err);
      }
    });
    return props;
  }
}
class BaseEventProps {
  constructor() {
    this.description = "";
    this.page = "";
  }
}
class AsideViewedProps extends BaseEventProps {
}
class ButtonClickedProps extends BaseEventProps {
  constructor() {
    super(...arguments);
    this.section = "";
    this.text = "";
  }
}
class CheckboxClickedProps extends BaseEventProps {
  constructor() {
    super(...arguments);
    this.section = "";
    this.value = false;
  }
}
class DropdownItemSelectedProps extends BaseEventProps {
  constructor() {
    super(...arguments);
    this.text = "";
  }
}
class FormProps extends BaseEventProps {
  constructor() {
    super(...arguments);
    this.value = {};
  }
}
class IconClickedProps extends BaseEventProps {
  constructor() {
    super(...arguments);
    this.iconName = "";
    this.section = "";
  }
}
class InputEnteredProps extends BaseEventProps {
  constructor() {
    super(...arguments);
    this.section = "";
  }
}
class LinkClickedProps extends BaseEventProps {
  constructor() {
    super(...arguments);
    this.section = "";
    this.text = "";
  }
}
class ModalViewedProps extends BaseEventProps {
  constructor() {
    super(...arguments);
    this.section = "";
  }
}
class NavItemClickedProps extends BaseEventProps {
  constructor() {
    super(...arguments);
    this.fromUrl = "";
    this.text = "";
    this.toUrl = "";
  }
}
class NudgeViewedProps extends BaseEventProps {
}
class PageViewedProps extends BaseEventProps {
  constructor() {
    super(...arguments);
    this.fromUrl = "";
    this.toUrl = "";
  }
}
class TabClickedProps extends BaseEventProps {
  constructor() {
    super(...arguments);
    this.section = "";
    this.text = "";
  }
}
class ToggleClickedProps extends BaseEventProps {
  constructor() {
    super(...arguments);
    this.section = "";
    this.value = "";
  }
}
const eventNames = {
  asideViewed: "Aside Viewed",
  buttonClicked: "Button Clicked",
  checkboxClicked: "Checkbox Clicked",
  dropdownItemSelected: "Dropdown Item Selected",
  formSubmitted: "Form Submitted",
  formViewed: "Form Viewed",
  iconClicked: "Icon Clicked",
  inputEntered: "Input Entered",
  linkClicked: "Link Clicked",
  modalViewed: "Modal Viewed",
  navItemClicked: "Nav Item Clicked",
  nudgeViewed: "Nudge Viewed",
  pageViewed: "Page Viewed",
  tabClicked: "Tab Clicked",
  toggleClicked: "Toggle Clicked"
};
const eventClassLookup = {
  asideViewed: new AsideViewedProps(),
  buttonClicked: new ButtonClickedProps(),
  checkboxClicked: new CheckboxClickedProps(),
  dropdownItemSelected: new DropdownItemSelectedProps(),
  formSubmitted: new FormProps(),
  formViewed: new FormProps(),
  iconClicked: new IconClickedProps(),
  inputEntered: new InputEnteredProps(),
  linkClicked: new LinkClickedProps(),
  modalViewed: new ModalViewedProps(),
  navItemClicked: new NavItemClickedProps(),
  nudgeViewed: new NudgeViewedProps(),
  pageViewed: new PageViewedProps(),
  tabClicked: new TabClickedProps(),
  toggleClicked: new ToggleClickedProps()
};
class EventController {
  constructor(eventManager) {
    this.eventManager = eventManager != null ? eventManager : new EventManager();
  }
  triggerAsideViewed(props) {
    this.trigger("asideViewed", props);
  }
  triggerButtonClicked(props) {
    this.trigger("buttonClicked", props);
  }
  triggerCheckboxClicked(props) {
    this.trigger("checkboxClicked", props);
  }
  triggerDropdownItemSelected(props) {
    this.trigger("dropdownItemSelected", props);
  }
  triggerFormSubmitted(props) {
    this.trigger("formSubmitted", props);
  }
  triggerFormViewed(props) {
    this.trigger("formViewed", props);
  }
  triggerIconClicked(props) {
    this.trigger("iconClicked", props);
  }
  triggerInputEntered(props) {
    this.trigger("inputEntered", props);
  }
  triggerLinkClicked(props) {
    this.trigger("linkClicked", props);
  }
  triggerModalViewed(props) {
    this.trigger("modalViewed", props);
  }
  triggerNavItemClicked(props) {
    this.trigger("navItemClicked", props);
  }
  triggerNudgeViewed(props) {
    this.trigger("nudgeViewed", props);
  }
  triggerPageViewed(props) {
    this.trigger("pageViewed", props);
  }
  triggerTabClicked(props) {
    this.trigger("tabClicked", props);
  }
  triggerToggleClicked(props) {
    this.trigger("toggleClicked", props);
  }
  getMissingProps(event, props) {
    const expectedKeys = Object.keys(eventClassLookup[event]);
    const existingKeys = Object.keys(props).filter((key) => props[key] !== void 0);
    const missingProps = expectedKeys.filter((key) => !existingKeys.includes(key));
    if (missingProps.includes("page") && existingKeys.includes("location")) {
      missingProps.splice(missingProps.indexOf("page"), 1);
      console.warn(`Missing [page] prop for ${event} event but found [location]. Please migrate [location] => [page].`);
    }
    return missingProps;
  }
  trigger(event, props) {
    if (!Object.keys(eventNames).includes(event)) {
      console.error(`Invalid event type: ${event}`);
      return;
    }
    const missingProps = this.getMissingProps(event, __spreadValues({}, props));
    if (missingProps.length > 0) {
      console.error(`${event} event is missing required properties: [${missingProps.join(", ")}]`);
      return;
    }
    this.eventManager.triggerEvent(eventNames[event], __spreadValues({}, props));
  }
}
function loadSegment(writeKey) {
  const cdnBaseUrl = "https://segmentcdn.jumpcloud.com";
  var analytics = window.analytics = window.analytics || [];
  if (analytics.initialize)
    return;
  if (analytics.invoked) {
    if (window.console && console.error) {
      console.error("Segment snippet included twice.");
    }
    return;
  }
  analytics.invoked = true;
  analytics.methods = [
    "trackSubmit",
    "trackClick",
    "trackLink",
    "trackForm",
    "pageview",
    "identify",
    "reset",
    "group",
    "track",
    "ready",
    "alias",
    "debug",
    "page",
    "once",
    "off",
    "on",
    "addSourceMiddleware",
    "addIntegrationMiddleware",
    "setAnonymousId",
    "addDestinationMiddleware"
  ];
  analytics.factory = function(method) {
    return function() {
      var args = Array.prototype.slice.call(arguments);
      args.unshift(method);
      analytics.push(args);
      return analytics;
    };
  };
  for (var i = 0; i < analytics.methods.length; i++) {
    let key = analytics.methods[i];
    analytics[key] = analytics.factory(key);
  }
  analytics.load = function(key, options) {
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.src = cdnBaseUrl + "/analytics.js/v1/" + key + "/analytics.min.js";
    var first = document.getElementsByTagName("script")[0];
    first.parentNode.insertBefore(script, first);
    analytics._loadOptions = options;
  };
  analytics._writeKey = writeKey;
  analytics._cdn = cdnBaseUrl;
  analytics.SNIPPET_VERSION = "4.15.2";
  analytics.load(writeKey);
}
const deepClone = (data) => data === void 0 ? {} : JSON.parse(JSON.stringify(data));
const hashString = (data) => data ? shajs("sha256").update(data).digest("hex") : "";
function handleHashedTraits(userTraits) {
  const hashedTraits = deepClone(userTraits == null ? void 0 : userTraits.hashed);
  const unhashedTraits = deepClone(userTraits);
  unhashedTraits == null ? true : delete unhashedTraits.hashed;
  if (userTraits && userTraits.hashed && hashedTraits) {
    for (const key in userTraits.hashed) {
      hashedTraits[key] = hashString(userTraits.hashed[key] || "");
    }
  }
  const traits = __spreadValues(__spreadValues({}, hashedTraits), unhashedTraits);
  return traits;
}
function initializeIdentity(options) {
  if (!window || !window.analytics)
    return;
  if (!options.userId) {
    throw new Error("options.userId must be defined to initialize segment");
  }
  const hashedUserId = hashString(options.userId);
  let mergedTraits = {};
  if (options.traits) {
    mergedTraits = handleHashedTraits(options.traits);
  }
  const traits = __spreadValues({
    userId: hashedUserId
  }, mergedTraits);
  window.analytics.identify(hashedUserId, traits);
  if (options.groupBy && traits[options.groupBy]) {
    window.analytics.group(traits[options.groupBy]);
  } else if (options.groupBy && !traits[options.groupBy]) {
    throw new Error("The given groupBy key does not exist in options");
  } else {
    window.analytics.group(hashedUserId);
  }
}
function setupSegment(writeKey) {
  return new Promise((resolve, reject) => {
    if (!writeKey) {
      reject("options.writeKey must be defined to initialize segment");
    }
    const timeout = setTimeout(resolve, 5e3);
    loadSegment(writeKey);
    if (window.analytics) {
      window.analytics.ready(() => {
        clearTimeout(timeout);
        resolve();
      });
    }
  });
}
function initialize(callback) {
  if (!window || !window.analytics)
    return;
  window.analytics.page();
  if (callback) {
    callback({
      isMobile: getIsMobile()
    });
  }
}
function isUserIdDefined(obj) {
  return !!obj.userId;
}
function setupEventTracking(options, callback) {
  return __async(this, null, function* () {
    yield setupSegment(options.writeKey);
    if (isUserIdDefined(options)) {
      initializeIdentity(options);
    }
    initialize(callback);
  });
}
function anonymousIdentify(options) {
  if (!window || !window.analytics)
    return;
  if (Object.keys(options.traits).length === 0) {
    throw new Error("options.traits must have values to call identify anonymously");
  }
  const traits = handleHashedTraits(options.traits);
  window.analytics.identify(traits);
}
let UiEvents = new EventController();
function initUiEvents(options) {
  UiEvents = new EventController(new EventManager(options));
}
export {
  UiEvents,
  anonymousIdentify,
  initUiEvents,
  initializeIdentity,
  setupEventTracking
};
